import React, { useEffect, useState } from "react";
import "../styles/Dashboard.css";

const AnimatedTaps = ({ tapA, tapB, tapC }) => {
    const [prevTaps, setPrevTaps] = useState({ tapA: 0, tapB: 0, tapC: 0 });
    const [animate, setAnimate] = useState({ tapA: false, tapB: false, tapC: false });

    useEffect(() => {
        if (tapA !== prevTaps.tapA) {
            setAnimate(prev => ({ ...prev, tapA: true }));
            setTimeout(() => setAnimate(prev => ({ ...prev, tapA: false })), 500);
        }
        if (tapB !== prevTaps.tapB) {
            setAnimate(prev => ({ ...prev, tapB: true }));
            setTimeout(() => setAnimate(prev => ({ ...prev, tapB: false })), 500);
        }
        if (tapC !== prevTaps.tapC) {
            setAnimate(prev => ({ ...prev, tapC: true }));
            setTimeout(() => setAnimate(prev => ({ ...prev, tapC: false })), 500);
        }
        setPrevTaps({ tapA, tapB, tapC });
    }, [tapA, tapB, tapC]);

    return (
        <div className="tap-container">
            <h3 className="tap-title">💧 Total Galon yang Keluar Hari Ini dari:</h3>
            {["A", "B", "C"].map((tap) => {
                const tapValue = tap === "A" ? tapA : tap === "B" ? tapB : tapC;
                return (
                    <div key={tap} className="tap-section">
                        <div className={`tap ${animate[`tap${tap}`] ? "shake" : ""}`}>
                            🚰 Keran {tap}
                        </div>
                        <div className="water-flow"></div>
                        <div className={`gallon ${animate[`tap${tap}`] ? "pulse" : ""}`}>
                            {tapValue} galon
                        </div>
                    </div>
                );
            })}
        </div>

    );
};

export default AnimatedTaps;
